import axios from 'axios';
// import { Message } from 'element-ui';

const service = axios.create({
  baseURL: process.env.BASE_API,
  headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  timeout: 60000
})

service.interceptors.request.use(config => {

  const token = localStorage.getItem('token');

  config.headers['x-channel'] = 1;
  if (token) {
    config.headers['X-Auth-Token'] = token;
  }
  const lang = localStorage.getItem('lang')
  if (!config.params) {
    config.params = {};
  }
  config.params['lang'] = lang;

  return config;
}, error => {
  Promise.reject(error);
});

service.interceptors.response.use(response => {
  const res = response.data;
  if (res.status == 201 || res.status == 303) {
    window.location.href = "#/Login";
  }
  return response;
}, error => {
  return Promise.reject(error);
})

export default service;
